import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import MenuList from './menu/MenuList';
import { useLocalStorage } from '../util/hooks';
import '../styles/sidebar.scss';
import { removeCssClass } from '../util/general';

const Sidebar = ({ disabled = false }) => {
  const [showMiniMenu, setShowMiniMenu] = useLocalStorage('showMiniMenu', true);
  const [showSideBar, setShowSideBar] = useLocalStorage('showSideBar', true);
  const [sideBarTheme] = useLocalStorage('sideBarTheme', 'dark');

  const isDisabled = disabled || !showSideBar;

  const className = classNames('no-print', {
    mini: showMiniMenu && window.innerWidth > 1024,
    [sideBarTheme]: true,
    disabled: isDisabled,
  });

  const toggleSideBar = value => {
    setShowSideBar(value);

    if (!value) {
      setShowMiniMenu(false);
    }
  };

  const closeMenu = () => {
    const element = document.getElementById('side-bar');
    if (element) {
      removeCssClass(element, 'open');
    }
  };

  return (
    <div id="side-bar" className={className}>
      <div className="side-bar-menu">
        <MenuList toggleSideBar={toggleSideBar} closeMenu={closeMenu} />
      </div>
      {isDisabled && <div className="side-bar-overlay" onClick={() => closeMenu()} />}
    </div>
  );
};

Sidebar.propTypes = {
  disabled: PropTypes.bool,
};

export default Sidebar;
